import { Box } from '@mui/material';
import { CuboidToolbar } from './Cuboids';

export const TopToolbar = () => {
  return (
    <Box sx={{ padding: '10px', minHeight: '80px' }}>
      <CuboidToolbar />
    </Box>
  );
};
